module.exports = __webpack_public_path__ + "media/images/top/scene03-a7b47de2252ca30b3daa4afd8ffbb7b7.jpg";